export function getMediaTypeLabel(mediaType: string) {
  switch (mediaType) {
    case 'video':
      return 'GENERAL.LABEL.VIDEO';
    case 'audio':
      return 'GENERAL.LABEL.AUDIO';
    case 'application':
      return 'GENERAL.LABEL.DOCUMENT';
    case 'text':
      return 'GENERAL.LABEL.RICH_CONTENT';
    case 'image':
      return 'GENERAL.LABEL.IMAGE';
    case 'typeform':
      return 'GENERAL.LABEL.TYPEFORM';
    default:
      return 'GENERAL.LABEL.UNCATEGORIZED';
  }
}

export function getMediaTypeIconClasses(mediaType: string) {
  switch (mediaType) {
    case 'video':
      return 'fal fa-video';
    case 'audio':
      return 'fal fa-music';
    case 'application':
      return 'fal fa-file-alt';
    case 'image':
      return 'fal fa-image';
    default:
      return '';
  }
}
